import { render, staticRenderFns } from "./viewPage.vue?vue&type=template&id=41087af3&scoped=true&"
import script from "./viewPage.vue?vue&type=script&lang=js&"
export * from "./viewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41087af3",
  null
  
)

export default component.exports